// extracted by mini-css-extract-plugin
module.exports = {"value":"TokenBalanceInfo_value__k2RVT","error":"TokenBalanceInfo_error__J7Kjk"};